import styles from './styles.module.css';
import ModuloContainerGaleriaNotas, {
    ModuloContainerGaleriasVerMas
} from '@/widgets/Nota/Templates/ModuloContainerGaleriaNotas';

const SeccionGalerias = (props) => {
    const { title, link, content = [] } = props;

    if (!content.length) {
        return null;
    }

    return (
        <div className={`${styles["pisoseccion-p"]}`}>
            {title && (
                <div className={`${styles["contenedor-gral-tittulo-container"]}`}>
                    <div className={`${styles["contenedor-left-titulo"]}`}>
                        <h2><a href={link}>{title}</a></h2>
                    </div>
                </div>
            )}

            <div className={`${styles["pisoseccion-parent"]}`}>
                <div className={`${styles['segundo-bloque']}`}>

                    {content.map((el, index) => (
                        <div className={` ${styles["grid-item"]}`} key={el._id || index}>
                            <ModuloContainerGaleriaNotas {...el} />
                        </div>
                    ))}

                    <div className={` ${styles["grid-item"]}`}>
                        <ModuloContainerGaleriasVerMas />
                    </div>

                </div>
            </div>
        </div>
    )
}

export default SeccionGalerias;